import { EstablishmentCategory } from '@/modules/accredited-establishments/api/types'

const isSpecialist = (category: EstablishmentCategory) =>
  category === 'SPECIALIST'

export { isSpecialist }
